<div class="itinerary-model-content-inner">
  <div class="itinerary-model-content">
    <form [formGroup]="itemsForm">
      <div class="box-title-container mb-1" *ngIf="!generatingVoucher">
        <div class="">
          <div class="d-flex align-items-center">
            <div class="icon-container">
              <ion-icon name="document-text"></ion-icon>
            </div>
            <div>
              <p class="title">Payment T&C's</p>
            </div>
          </div>
        </div>
      </div>
      <div class="form-container ion-padding-horizontal">
        <div class="row">
          <div class="col">
            <div class="input-container">
              <app-selectable-list-items 
                [addButtonText]="'Add Payment Terms & Conditions'"
                formControlName="paymentTermsAndConditions"
                (setDefaultEmitter)="setDefaultLov($event, 'PaymentTermsAndConditions', 'paymentTermsAndConditions')"
                (removeDefaultEmitter)="removeDefaultLov($event, 'PaymentTermsAndConditions', 'paymentTermsAndConditions')"
              ></app-selectable-list-items>
            </div>
          </div>
        </div>

        <div class="add-inclusion-main-container">
          <div class="row">
            <div class="col">
              <div class="input-container">
                <label for class="label">Notes</label>
                <div>
                  <app-text-formatting-input formControlName="note"></app-text-formatting-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dashed-line"></div>
    </form>
  </div>

  <div class="ion-padding-horizontal justify-content-between itinerary-model-footer" *ngIf="!generatingVoucher && !hideFooter">
    <div class="d-flex align-items-center">
      <ion-button class="unfilled-blue-btn" [disabled]="formDataModified()" (click)="goPrevious()">
        <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
      </ion-button>
      <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
        Reset
      </ion-button>
    </div>
    
    <div class="d-flex align-items-center">
      <ion-button class="filled-blue-btn" (click)="onSubmit()">
        Save
      </ion-button>
      <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="formDataModified()">
        <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </div>
  </div>

</div>